// server_api3 (api3.sigmachart.co.kr) 전용 API 인스턴스
// 공개 Drug 조회 등에서 사용한다. X-Api-Key 헤더로 인증한다.
import axios from "axios"
import axiosRetry from "axios-retry"
import { RETRY_COUNT, SERVER_API3_DEV, SERVER_API3_PROD, SERVER_API3_PUBLIC_KEY } from "@core/config"
import { limitedRequest } from "./limiter"

const BASE_URL = import.meta.env.DEV ? SERVER_API3_DEV : SERVER_API3_PROD

const api3Instance = axios.create({
  baseURL: BASE_URL,
  timeout: 15_000,
})

axiosRetry(api3Instance, {
  retries: RETRY_COUNT,
  retryDelay: retryCount => Math.min(1000 * retryCount, 400),
  retryCondition: error => {
    const method = error.config?.method?.toLowerCase()
    if (method === "delete") return false
    return axiosRetry.isNetworkOrIdempotentRequestError(error)
  },
})

api3Instance.interceptors.request.use((config: any) => {
  config.headers = config.headers || {}
  // API Key 인증
  config.headers["X-Api-Key"] = SERVER_API3_PUBLIC_KEY
  return config
})

api3Instance.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    console.error(`[API3 ✕] ${error.code || error.message} → ${error.config?.url}`, error.response?.status)
    return Promise.reject(error)
  }
)

export const api3ServerApi = {
  get: <T = any>(url: string, config?: any): Promise<any> => limitedRequest(() => api3Instance.get<T>(url, config) as Promise<any>),
}
